import React from "react";
import { Route, Routes } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import Login from "../pages/Login";
import Home from "../pages/Home";
import Register from "../pages/Register";
import NewBlog from "../pages/NewBlog";
import About from "../pages/About";
import BlogDetailed from "../components/blog/BlogDetailed";
import PrivateRouter from "./PrivateRouter";
import ScrollToTop from "../pages/ScrollToTop";
import MyBlogs from "../pages/MyBlogs";
const AppRouter = () => {
  return (
    <div>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Dashboard />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />
          <Route path="Newblog" element={<NewBlog />} />

          <Route path="blogDetailed/:idx" element={<PrivateRouter />}>
            <Route path="" element={<BlogDetailed />} />
          </Route>
          <Route path="myBlogs" element={<PrivateRouter />}>
            <Route path="" element={<MyBlogs />} />
          </Route>
        </Route>
      </Routes>
    </div>
  );
};

export default AppRouter;
